import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter valid email address"),
  password: z
    .string()
    .min(1, "Password is required"),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const defaultValues: LoginFormData = {
  email: "",
  password: "",
};

export const PAGE_CONFIG = {
  TITLE: "Get Started Now",
} as const;
